import {
  DaughterIcon,
  FemaleIcon,
  MaleIcon,
  ParentsIcon,
  RingIcon,
  SonIcon
} from './icons';
import PersonIcon from '@mui/icons-material/Person';
import { Chip } from '@mui/material';
import { camelCase, startCase } from 'lodash';
import { Button, ButtonGroup, Tooltip } from '@mui/material';

const {
  Numbers,
  Edit,
  HourglassEmpty,
  CheckCircleOutline,
  Replay,
  CancelOutlined,
  DoneAll,
  Warning
} = require('@mui/icons-material');

export const summaryData = [
  {
    title: 'ALL',
    value: 0,
    color: '#1A237E',
    icon: <Numbers fontSize="medium" sx={{ color: '#1A237E' }} />
  },
  // {
  //   title: 'RECTIFICATION',
  //   value: 0,
  //   color: '#FFA726',
  //   icon: <Edit fontSize="medium" sx={{ color: '#FFA726' }} />
  // },
  {
    title: 'IN_PROGRESS',
    value: 0,
    color: '#29B6F6',
    icon: <HourglassEmpty fontSize="medium" sx={{ color: '#29B6F6' }} />
  },
  {
    title: 'Approved',
    value: 0,
    color: '#2E7D32',
    icon: <CheckCircleOutline fontSize="medium" sx={{ color: '#2E7D32' }} />
  },
  {
    title: 'RESUBMIT',
    value: 0,
    color: '#9E9E9E',
    icon: <Replay fontSize="medium" sx={{ color: '#9E9E9E' }} />
  },
  {
    title: 'REJECTED',
    value: 0,
    color: '#D32F2F',
    icon: <CancelOutlined fontSize="medium" sx={{ color: '#D32F2F' }} />
  },
  {
    title: 'SETTELED',
    value: 0,
    color: '#7B1FA2',
    icon: <DoneAll fontSize="medium" sx={{ color: '#7B1FA2' }} />
  }
  // {
  //   title: 'OverDue',
  //   value: 0,
  //   color: '#EF6C00',
  //   icon: <Warning fontSize="medium" sx={{ color: '#EF6C00' }} />
  // }
];

const STATUS_STYLES = {
  FO_APPROVED: { color: '#2e7d32', bg: '#e8f5e9' },
  DOC_REJECTED: { color: '#c62828', bg: '#ffebee' },
  REVIEWER_LEVEL_TWO: { color: '#1565c0', bg: '#e3f2fd' },
  DOC_IN_PROCESS: { color: '#ef6c00', bg: '#fff3e0' },
  DRAFT: { color: '#6d4c41', bg: '#efebe9' },
  PARTIAL_SETTLE: { color: '#00838f', bg: '#e0f7fa' },
  IO_REJECTED: { color: '#ad1457', bg: '#fce4ec' },
  FO_IN_PROCESS: { color: '#ef6c00', bg: '#fff3e0' },
  REJECTED: { color: '#c62828', bg: '#ffebee' },
  REVIEWER_LEVEL_ONE_INP: { color: '#ef6c00', bg: '#fff3e0' },
  IO_IN_PROCESS: { color: '#ef6c00', bg: '#fff3e0' },
  SETTELED: { color: '#2e7d32', bg: '#e8f5e9' },
  IO_RE_SUBMIT: { color: '#6a1b9a', bg: '#f3e5f5' },
  NEW: { color: '#1976d2', bg: '#e3f2fd' },
  FO_REJECTED: { color: '#c62828', bg: '#ffebee' },
  APPROVE: { color: '#2e7d32', bg: '#e8f5e9' },
  PENDING: { color: '#00838f', bg: '#e0f7fa' },
  'IN PROGRESS': { color: '#ef6c00', bg: '#fff3e0' },
  'In Progress': { color: '#ef6c00', bg: '#fff3e0' }
};

const StatusTag = ({ status, size = 'md' }) => {
  const { color, bg } = STATUS_STYLES[status?.toUpperCase()] || {
    color: '#616161',
    bg: '#f5f5f5'
  };

  // Size config
  const sizeMap = {
    sm: {
      fontSize: '0.6rem',
      padding: '2px 8px',
      dotSize: 6,
      gap: '4px'
    },
    md: {
      fontSize: '0.75rem',
      padding: '4px 10px',
      dotSize: 8,
      gap: '6px'
    },
    lg: {
      fontSize: '0.85rem',
      padding: '6px 12px',
      dotSize: 10,
      gap: '8px'
    },
    xl: {
      fontSize: '1rem',
      padding: '6px 12px',
      dotSize: 12,
      gap: '8px'
    }
  };

  const currentSize = sizeMap[size] || sizeMap['md'];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: currentSize.gap,
        padding: currentSize.padding,
        backgroundColor: bg,
        color: color,
        fontSize: currentSize.fontSize,
        borderRadius: '999px',
        fontWeight: 500,
        textTransform: 'capitalize',
        width: 'max-content'
      }}
    >
      <span
        style={{
          width: currentSize.dotSize,
          height: currentSize.dotSize,
          borderRadius: '50%',
          backgroundColor: color
        }}
      ></span>
      {status?.replace(/_/g, ' ').toLowerCase()}
    </span>
  );
};

export default StatusTag;

export function GetHeader(member, size) {
  let relation = member?.relation.toUpperCase();

  if (relation === 'SELF' && member?.gender === 'MALE')
    return <MaleIcon size={size} className="absolute" />;

  if (relation === 'SELF' && member?.gender === 'FEMALE')
    return <FemaleIcon className="absolute" size={size}></FemaleIcon>;

  if (
    relation === 'SELF' &&
    (member?.gender === 'OTHER' || member?.gender === 'OTHERS')
  )
    return <PersonIcon size={size} className="absolute" />;

  if (relation === 'HUSBAND' && member?.gender === 'MALE')
    return <MaleIcon size={size} className="absolute" />;

  if (
    relation !== 'SELF' &&
    (member?.gender === 'OTHER' || member?.gender === 'OTHERS')
  )
    return <PersonIcon size={size} className="absolute" />;

  if (relation === 'SPOUSE' || relation === 'WIFE')
    return <RingIcon size={size} className="absolute"></RingIcon>;

  if (relation === 'DAUGHTER')
    return <DaughterIcon size={size} className="absolute"></DaughterIcon>;

  if (relation === 'SON')
    return <SonIcon size={size} className="absolute"></SonIcon>;

  if (relation === 'PARENT')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'MOTHER')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'FATHER')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'BROTHER')
    return <MaleIcon size={size} className="absolute" />;

  if (relation === 'SISTER')
    return <DaughterIcon size={size} className="absolute"></DaughterIcon>;

  if (relation === 'SIBLING')
    return <MaleIcon size={size} className="absolute" />;
  if (relation === 'NEIGHBOUR')
    return <MaleIcon size={size} className="absolute" />;

  if (relation === 'SON_IN_LAW' || relation === 'SON-IN-LAW')
    return <SonIcon size={size} className="absolute"></SonIcon>;
  if (relation === 'GRAND-SON' || relation === 'GRAND SON')
    return <SonIcon size={size} className="absolute"></SonIcon>;

  if (relation === 'DAUGHTER_IN_LAW' || relation === 'DAUGHTER-IN-LAW')
    return <DaughterIcon size={size} className="absolute"></DaughterIcon>;

  if (relation === 'BROTHER_IN_LAW' || relation === 'BROTHER-IN-LAW')
    return <MaleIcon size={size} className="absolute"></MaleIcon>;

  if (relation === 'SISTER_IN_LAW' || relation === 'SISTER-IN-LAW')
    return <DaughterIcon size={size} className="absolute"></DaughterIcon>;

  if (relation === 'MOTHER_IN_LAW' || relation === 'MOTHER-IN-LAW')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'FATHER_IN_LAW' || relation === 'FATHER-IN-LAW')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'SELF_PARENT_1' || relation === 'SELF_PARENT_2')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'SPOUSE_PARENT_1' || relation === 'SPOUSE_PARENT_2')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;

  if (relation === 'SPOUSE_PARENT' || relation === 'SPOUSE-PARENT')
    return <ParentsIcon size={size} className="absolute"></ParentsIcon>;
}

export const handlePaginationData = (response) => {
  if (!response || !response.content || !response.pageable) {
    return {
      data: [],
      currentPage: 0,
      totalPages: 0,
      totalCount: 0
    };
  }

  return {
    data: response?.content,
    currentPage: response?.pageable?.pageNumber + 1, // pageNumber is 0-indexed
    totalPages: response?.totalPages,
    totalCount: response?.totalElements
  };
};

export const getParsedTimeValue = (value) => {
  let newValue = value;
  if (newValue) {
    newValue = value?.split(' ')[0];
    let timeValue = value?.split(' ')[1] || '00:00:00';
    let dateFormatter = newValue.split('-'); //dd-mm-yyyy
    newValue = new Date(
      `${dateFormatter[2]}-${dateFormatter[1]}-${dateFormatter[0]} ${timeValue}` //yyyy-mm-dd 00:00:00 (yyyy/MM/dd(you can have any format of date according to browser's supported date format) HH:mm:ss(this is required), this will work in all the browsers)
    );
  }
  return newValue;
};

export const NameTag = ({ name, backgroundColor, textColor }) => {
  const { color, bg } = {
    color: '#00838f',
    bg: '#e0f7fa'
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        backgroundColor: backgroundColor ? backgroundColor : bg,
        color: textColor ? textColor : color,
        fontSize: '0.65rem',
        borderRadius: '999px',
        fontWeight: 500,
        textTransform: 'capitalize'
      }}
    >
      {name}
    </span>
  );
};

const humanize = (str) => startCase(camelCase(str));

export const PennyDropStatusBadge = ({ status }) => {
  const statusColors = {
    pennyDropPending: 'warning',
    pennyDropOverride: 'info',
    pennyDropFailed: 'error',
    pennyDropSuccess: 'success',
    pennyDrop: 'default'
  };

  return (
    <Chip
      label={humanize(status)}
      color={statusColors[status] || 'default'}
      size="small"
      variant="outlined"
    />
  );
};

export const PennyDropActionGroup = ({
  validatePennydrop,
  setOpen,
  isShowOverrideIcon
}) => {
  return (
    <ButtonGroup
      disableElevation
      variant="outlined"
      size="small"
      sx={{
        borderRadius: '16px',
        '& .MuiButton-root': {
          borderRadius: '16px',
          textTransform: 'none',
          fontSize: '0.75rem',
          padding: '4px 10px',
          borderColor: '#0288d1', // matches info color
          color: '#0288d1',
          '&:hover': {
            borderColor: '#0277bd',
            backgroundColor: '#e1f5fe'
          }
        }
      }}
    >
      <Tooltip title="Retry pennydrop verification" arrow>
        <Button onClick={validatePennydrop}>Retry</Button>
      </Tooltip>

      {!isShowOverrideIcon && (
        <Tooltip title="Override pennydrop verification" arrow>
          <Button onClick={() => setOpen(true)}>Override</Button>
        </Tooltip>
      )}
    </ButtonGroup>
  );
};

export const approveRejectSettleStatuses = [
  'APPROVE',
  'APPROVED',
  'Approved',
  'IO_APPROVED',
  'DOC_APPROVED',
  'DOC_SPL_APPROVED',
  'FO_APPROVED',
  'SETTELED', // typo for SETTLED
  'SETTLED',
  'PARTIAL_SETTLE',
  'REJECT',
  'REJECTED',
  'IO_REJECTED',
  'DOC_REJECTED',
  'DOC_SPL_REJECTED',
  'FO_REJECTED',
  'REVIEWER_LEVEL_ONE_REJECT',
  'REVIEWER_LEVEL_TWO_REJECT',
  'IO_RE_SUBMIT',
  'DOC_RE_SUBMIT',
  'DOC_SPL_RE_SUBMIT',
  'FO_RE_SUBMIT',
  'REVIEWER_LEVEL_ONE_RESUBMIT',
  'REVIEWER_LEVEL_TWO_RESUBMIT'
];

export const reviewerState = {
  IO_Reviewer: [
    ...approveRejectSettleStatuses,
    'REVIEWER_LEVEL_TWO_INP',
    'DOC_IN_PROCESS',
    'DOC_SPL_IN_PROCESS',
    'FO_IN_PROCESS',
    'REVIEWER_LEVEL_ONE_INP'
  ],
  FO_Reviewer: [
    ...approveRejectSettleStatuses,
    'REVIEWER_LEVEL_TWO_INP',
    'DOC_IN_PROCESS',
    'DOC_SPL_IN_PROCESS',
    'REVIEWER_LEVEL_ONE_INP',
    'IO_IN_PROCESS'
  ],

  DOC_Reviewer: [
    ...approveRejectSettleStatuses,
    'REVIEWER_LEVEL_TWO_INP',
    'REVIEWER_LEVEL_ONE_INP',
    'IO_IN_PROCESS',
    'FO_IN_PROCESS'
  ],
  claim_manager_reviewer: [
    ...approveRejectSettleStatuses,
    'REVIEWER_LEVEL_TWO_INP',
    'IO_IN_PROCESS',
    'FO_IN_PROCESS',
    'DOC_IN_PROCESS'
  ],
  higher_level_reviewer: [
    ...approveRejectSettleStatuses,
    'REVIEWER_LEVEL_ONE_INP',
    'IO_IN_PROCESS',
    'FO_IN_PROCESS',
    'DOC_IN_PROCESS'
  ]
};

export const MovedTag = ({ status, movedBy }) => {
  const { color, bg } = STATUS_STYLES[status] || {
    color: '#616161',
    bg: '#f5f5f5'
  };

  const formattedStatus = status.replace(/_/g, ' ').toLowerCase();

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        backgroundColor: bg,
        color: color,
        fontSize: '0.65rem',
        borderRadius: '999px',
        fontWeight: 500,
        textTransform: 'capitalize',
        width: 'max-content'
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color
        }}
      ></span>
      {`moved to ${formattedStatus}`}
      {movedBy && (
        <span style={{ color: '#888', marginLeft: 4 }}>by {movedBy}</span>
      )}
    </span>
  );
};

export function toTitleCase(str) {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const parts = dateString.split('-'); // ["2025","09","10"]
  if (parts.length !== 3) return dateString;
  return `${parts[2]}-${parts[1]}-${parts[0]}`; // "10-09-2025"
};

export const disableFutureDates = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to the beginning of today for accurate comparison
  return date > today; // Disable if the date is after today
};
